{
  "url": "wss://la-box-medicale.ajonc.fr/cable"
}